export const waitForElement = (selector: string, timeout = 10000): Promise<Element | null> => new Promise((resolve) => {
  const element = document.querySelector(selector);
  if (element) {
    resolve(element);
    return;
  }

  let rafId: number | null = null;
  let timeoutId: NodeJS.Timeout | null = null;
  let observer: MutationObserver | null = null;

  const cleanup = () => {
    if (observer) observer.disconnect();
    if (rafId) cancelAnimationFrame(rafId);
    if (timeoutId) clearTimeout(timeoutId);
  };

  const checkElement = () => {
    rafId = null;
    const foundElement = document.querySelector(selector);
    if (foundElement) {
      cleanup();
      resolve(foundElement);
    }
  };

  observer = new MutationObserver(() => {
    if (!rafId) {
      rafId = requestAnimationFrame(checkElement);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  timeoutId = setTimeout(() => {
    cleanup();
    resolve(null);
  }, timeout);
});
